import { TableCellType } from "src/modules/sm-base/netgen/TableCellType";

export enum GenericDataType {
    //netgen start
    string = 0,
    int = 1,
    decimal = 2,
    bool = 3,
    date = 4,
    dateTime = 5,
    time = 6,
    array = 7,
    object = 8
    //netgen end
}
export namespace GenericDataType{
    export function getName(value: GenericDataType): string {
        switch (value) {
            case GenericDataType.string:
                return "string";
            case GenericDataType.int:
                return "int";
            case GenericDataType.decimal:
                return "decimal";
            case GenericDataType.bool:
                return "bool";
            case GenericDataType.date:
                return "date";
            case GenericDataType.dateTime:
                return "dateTime";
            case GenericDataType.time:
                return "time";
            case GenericDataType.array:
                return "array";
            case GenericDataType.object:
                return "object";
        }
    }

    export function getDefaultValue(value: GenericDataType): any {
        switch (value) {
            case GenericDataType.string:
                return "";
            case GenericDataType.int:
                return 0;
            case GenericDataType.decimal:
                return 0;
            case GenericDataType.bool:
                return false;
            case GenericDataType.date:
                return null;
            case GenericDataType.dateTime:
                return null;
            case GenericDataType.time:
                return 0;
            case GenericDataType.array:
                return [];
            case GenericDataType.object:
                return null;
        }
    }

    export function toTableCellType(type: GenericDataType): TableCellType {
        switch (type) {
            case GenericDataType.string:
                return TableCellType.string;
            case GenericDataType.int:
                return TableCellType.int;
            case GenericDataType.decimal:
                return TableCellType.decimal;
            case GenericDataType.bool:
                return TableCellType.bool;
            case GenericDataType.date:
                return TableCellType.date;
            case GenericDataType.dateTime:
                return TableCellType.dateTime;
            default:
                return TableCellType.string;
        }
    }

    
}
